<template>
  <section class="sidebar">
    <logo
      v-if="layout === 'side'"
      :is-collapse="isCollapse"
    />
    <el-scrollbar :wrap-class="['scrollbar-wrapper', layout === 'mix' ? 'mix' : '']">
      <el-menu
        router
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="true"
        :collapse-transition="true"
        :mode="layout === 'top' ? 'horizontal' : 'vertical'"
      >
        <sidebar-item
          v-for="route in permissionRoutes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :is-collapse="isCollapse"
        />
      </el-menu>
    </el-scrollbar>
  </section>
</template>
<script lang="ts">
  import {
    defineComponent, reactive, toRefs, watch, computed,
  } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  import { usePermissionStore } from '@/store/modules/permission';
  import config from '@/config';
  import SidebarItem from './SidebarItem.vue';
  import Logo from '../Logo/index.vue';

  interface InterfaceState {
    activeMenu: any,
  }

  export default defineComponent({
    name: 'sidebar',
    components: {
      SidebarItem,
      Logo,
    },
    props: {
      isCollapse: {
        type: Boolean,
        default: false,
      },
    },
    setup() {
      const route = useRoute();
      const router = useRouter();
      const { getters } = useStore();
      const permissionStore = usePermissionStore();

      const state:InterfaceState = reactive({
        activeMenu: '', // 激活菜单的 index, index取的是路由中path的值
      });

      const layout = computed(() => getters.layout);
      const permissionRoutes = permissionStore.permissionRoutes;

      watch(route, (val) => {
        state.activeMenu = val?.meta?.activeMenu || val.path;
      }, {
        immediate: true,
      });

      return {
        ...toRefs(state),
        layout,
        permissionRoutes: config.sso ? permissionRoutes : router.options.routes,
      };
    },
  });
</script>

<style lang="scss" scoped>
  .sidebar {
    width: 100%;
    height: 100%;
    overflow-y: hidden;

    :deep(.scrollbar-wrapper) {
      // height: calc(100% - #{$--header-height}) !important;
      overflow-x: hidden;

      &.mix {
        height: 100% !important;
      }
    }

    :deep(.is-horizontal) {
      display: none;
    }

    // 修改 collapse 时的默认样式
    :deep(.el-menu--collapse) {
      .el-sub-menu__title {
        span {
          display: none !important;
        }
      }

      .el-sub-menu__icon-arrow {
        display: none !important;
        opacity: 0 !important;
      }
    }

    // 修改menu和menu-item的默认样式
    :deep(.el-menu) {
      //margin-top: 11px;
      border-right-width: 0;
      border-bottom: 0;

      .el-menu-item {
        display: flex;
        align-items: center;
      }
    }

    .el-menu--horizontal{
      height: auto;
    }
  }
</style>
